<template>
    <div class="user-stat-page-container">
        <div v-if="loading" class="d-flex justify-content-center m-2 tip_body" style="height: 10px;">
            <CSpinner
                color="info"
                style="width:4rem;height:4rem;"
            />
        </div>
        <CCard v-else bodyWrapper class="tip_body">
            <div class="username">
                <div class="d-flex" style="color: blue; font-weight: 600;">
                    <Avatar 
                        :key="stat.userAvatar"
                        :size="55"
                        :src="stat.userAvatar"
                        :username="stat.userName"
                        :userId="stat.userId"
                    />
                    &nbsp;<span :class="{'online-mark' : online, 'offline-mark' : !online}" ></span><p class="next_avatar_name_p">{{ stat.userName}}</p>
                </div>
            </div>
            <div class="stat">
                <!-- <div class="sub_stat"> -->

                <div class="tips">
                    <div>{{ $t('Tips') }}</div>
                    <div>{{ total_stat.total_tips}}<span v-if="userId == 0">({{ real_stat.total_tips }})</span></div>
                </div>
                <div class="profit-pts">
                    <div>{{ $t('Profit PTs') }}</div>
                    <div :class="{
                        'limegreen': total_stat.profit_pts >= 0,
                        'red': total_stat.profit_pts < 0}">
                        {{ total_stat.profit_pts}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.profit_pts >= 0,
                            'red': real_stat.profit_pts < 0}">
                            ({{ real_stat.profit_pts }})
                        </span>
                    </div>                    
                </div>
                <div class="roi">
                    <div>{{ $t('ROI %') }}</div>
                    <div :class="{
                        'limegreen': total_stat.roi >= 0,
                        'red': total_stat.roi < 0}">
                        {{ total_stat.roi}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.roi >= 0,
                            'red': real_stat.roi < 0}">
                            ({{ real_stat.roi }})
                        </span>
                    </div>
                </div>
                <div class="w-rate">
                    <div>{{ $t('W/Rate') }}</div>
                    <div :class="{
                        'limegreen': total_stat.w_rate >= 0,
                        'red': total_stat.w_rate < 0}">
                        {{ total_stat.w_rate}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.w_rate >= 0,
                            'red': real_stat.w_rate < 0}">
                            ({{ real_stat.w_rate }})
                        </span>
                    </div>
                </div>
                <div class="avg_odd">
                    <div>{{ $t('Avg Odd')}}</div>
                    <div>
                        {{ total_stat.avg_odd }} ({{ real_stat.avg_odd }})
                       
                    </div>
                </div>
                <div class="followers">
                    <div>Followers</div>
                    <div class="action-box" :key="total_stat.followers + ' ' + stat.followers">
                        <div :class="{
                                'action': true,
                                'selected': userIsFollowed
                            }">
                            {{ total_stat.followers}}
                            <span  v-if="$route.params.userId != loggedInUser.user_id"
                                v-c-tooltip="userIsFollowed ? $t('You already followed this tipster') : $t('Follow this tipster')"
                                @click="handleFollowUser_($route.params.userId, loggedInUser.user_id)">
                                <CIcon name="cil-user-follow" />
                            </span>
                            <span v-else>
                                <CIcon name="cil-user-follow" class="disabled" />
                            </span>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            <div class="strategy_name_bar">
                <p class="strategy_name1">Strategy name</p>
                <div class="stat" style="margin-top: 0px">
                    <span class="strategy-name">{{strategy.name}}</span>
                    <div class="followers">
                        <div>Followers</div>

                        <div class="action-box" :key="total_stat.followers + ' ' + stat.followers">
                            <div :class="{
                                'action': true,
                                'selected': strategyIsFollowed
                            }">
                                {{ stat.followers}}
                                <span  v-if="$route.params.userId != loggedInUser.user_id && strategy.name != 'default'"
                                    v-c-tooltip="strategyIsFollowed ? 'You already followed this strategy' : 'Follow this strategy'"
                                    @click="handleFollowStrategy_(strategy._id)">
                                    <CIcon name="cil-user-follow" />
                                </span>
                                <span v-else>
                                    <CIcon name="cil-user-follow" class="disabled" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="d-flex">
                <div class="font-weight-bold">Description:&nbsp;</div>
                <div style="flex: 1">{{ strategy.description }}</div>
            </div>

            
            <div class="stat stat1">
                <!-- <div class="sub_stat"> -->
                
                <div class="tips">
                    <div>Tips</div>
                    <div>{{ stat.total_tips}}</div>
                </div>
                <div class="profit-pts">
                    <div>Profit PTs</div>
                    <div v-if="stat.profit_pts >= 0" style="color: limegreen;">{{ stat.profit_pts}}</div>
                    <div v-else style="color: red;">{{ stat.profit_pts}}</div>
                </div>
                <div class="roi">
                    <div>ROI %</div>
                    <div v-if="stat.roi >= 0" style="color: limegreen;">{{ stat.roi}}</div>
                    <div v-else style="color: red;">{{ stat.roi}}</div>
                </div>
                <div class="w-rate">
                    <div>W/Rate</div>
                    <div v-if="stat.w_rate >= 0" style="color: limegreen;">{{ stat.w_rate}}</div>
                    <div v-else style="color: red;">{{ stat.w_rate}}</div>
                </div>
                <div class="avg_odd">
                    <div>{{ $t('Avg Odd')}}</div>
                    <div>
                        {{ stat.avg_odd }}
                       
                    </div>
                </div>

                <div style="display: flex; align-items: center;">                    
                    <CButton color="success" class="mx-1 detail_button2 strategy_stats_button" @click="handleStatsClick">{{$t('Stats')}}</CButton>
                    <CButton color="success" class="mx-1 detail_button2 strategy_stats_button" @click="handleFinancialClick">{{$t('Financial')}}</CButton>
                </div>
                <!-- <div style="display: flex; align-items: center;">
                    
                    <CButton color="success" class="mx-1 detail_button2 strategy_stats_button" @click="handleFinancialClick">{{$t('Financial')}}</CButton>
                </div> -->
                
            </div>

                <CCallout color="warning">
                    <strong class="h2">{{ $t('Pending Tips') }}</strong> - 
                    <span class="text-muted h4">{{unSettledList.length}}</span>
                </CCallout>
                <div :key="item._id" v-for="(item, index) in unSettledList" class="feed_card">
                    <post-card
                        :key="item._id"
                        :index="index"
                        :item="item"
                        :unread="notifications.find(nItem => nItem.tipId === item._id && !nItem.commentId && !nItem.readAt)"
                        :handleLikeTip="handleLikeTip"
                        :handleFollowTip="handleFollowTip"
                        :handleFollowUser="handleFollowUser"
                        :handlePostComment="handlePostComment"
                        :handleSelectReply="handleSelectReply"
                        :handleDeleteTip="handleDeleteTip"
                        :handleDeleteComment="handleDeleteComment"
                        :onCashOut="handleCashOut"
                        :loading="!!cashoutQueue.find(nItem => nItem._id === item._id && nItem.cashout_type === 0)"
                        :cover_loading="!!cashoutQueue.find(nItem => nItem._id === item._id && nItem.cashout_type === 1)"
                    />
                </div>
                <CCallout color="success">
                    <strong class="h2">{{ $t('Settled Tips') }}</strong> - 
                    <span class="text-muted h4">{{settledList.length}}</span>
                </CCallout>
                <div :key="item._id" v-for="(item, index) in settledList" class="feed_card">
                    <post-card
                        :key="item._id"
                        :index="index"
                        :item="item"
                        :unread="notifications.find(nItem => nItem.tipId === item._id && !nItem.commentId && !nItem.readAt)"
                        :handleLikeTip="handleLikeTip"
                        :handleFollowTip="handleFollowTip"
                        :handleFollowUser="handleFollowUser"
                        :handlePostComment="handlePostComment"
                        :handleSelectReply="handleSelectReply"
                        :handleDeleteTip="handleDeleteTip"
                        :handleDeleteComment="handleDeleteComment"
                    />
                </div>

                <div v-if="stat.total_tips > data.length" style="text-align: center;">
                    <CButton color="dark" class="align-items-center" @click="loadMore(settledList.length)" :disabled="loadmore_loading">
                        Load more
                        <CSpinner v-if="loadmore_loading" color="danger" size="sm" />
                    </CButton>
                </div>
            
        
        </CCard>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Swal from 'sweetalert2';

    import Avatar from '@/components/Avatar';
    import PostCard from '@/components/PostCard';
    import ListTable from '@/components/ListTable';

    import commonMixin from '@/mixins/common/commonMixin';
    import tipMixin from '@/mixins/TipMixin';
    import {capitalizeFL} from '@/helpers/string';
    import {displaySuccess} from '@/helpers/message';
    import {convertUTCToLocal, defaultFormat } from '@/helpers/time';

    export default {
        mixins: [commonMixin, tipMixin],
        components: {
            Avatar,
            PostCard,
            ListTable
        },
        data () {
            return {
                data: [],
                userId: '',
                stat: {
                    userName: '',
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    followers: '',
                    resetCount: 0,
                    description: '',
                    avg_odd: 0
                },
                total_stat: {
                    userName: '',
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    followers: '',
                    resetCount: 0,
                    description: '',
                    avg_odd: 0
                },
                real_stat: {                    
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    avg_odd: 0
                },
                strategy: {},
                notifications: [],
                loadmore_loading: false,
                userIsFollowed: false,
                strategyIsFollowed: false,
                cashOutTimer: null,
                online: false,
            }
        },
        computed: {
            ...mapGetters(['loggedInUser']),
            settledList(){
                let _data = this.data.filter(item => !!item.settled);
                return [..._data];
            },
            unSettledList(){
                let _data = this.data.filter(item => !item.settled);
                return [..._data];
            }
        },
        methods: {
            ...mapActions([
                'getFeedsByStrategy',
                'getFeedsByStrategy_',
                'getMyPendingFeeds',
                'postComment',
                'resetTip',
                'toggleLikeTip',
                'toggleFollowTip',
                'toggleFollowUser',
                'toggleFollowStrategy',
                'createStrategy',
                'getStrategies',
                'deleteStrategy',
                'deleteTip',
                'deleteComment',
                'cashOut',
                'postCashoutRef',
            ]),

             handleCashOut(tip_id, cashout_type, auto_cashout) {
                let idx = this.data.findIndex(item => item._id === tip_id);
                let cashout_item = {
                    ...this.data[idx],
                    cashout_type: cashout_type,
                    auto_cashout: auto_cashout,
                    first_input: true
                }
                this.cashoutQueue.push(cashout_item);
            },

            check_autoTipCashout(dItem, fIndex) {
                if (dItem.ref_profitPts) {
                    var val = parseFloat(dItem.ref_profitPts);
                    if (dItem.currentPointProfit >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_profitPro) {
                    var val = parseFloat(dItem.ref_profitPro);
                    var profitPro = 100 * (dItem.currentPointProfit / dItem.stake)
                    if (profitPro >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_stoploss) {
                    var val = -1 * parseFloat(dItem.ref_stoploss);
                    var profitPro = 100 * (dItem.currentPointProfit / dItem.stake) 
                    if (profitPro <= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_nextodd) {
                    var val = parseFloat(dItem.ref_nextodd);
                    
                    if (dItem.currentOdd && dItem.currentOdd >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_nextodd_lower) {
                    var val = parseFloat(dItem.ref_nextodd_lower);
                    
                    if (dItem.currentOdd && dItem.currentOdd <= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_time) {
                    var val = parseFloat(dItem.ref_time);                    
                    if (dItem.current_minute && dItem.current_minute >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_score) {
                    var old_score = dItem.ref_momnent_score;
                    var current_score = dItem.currentScore;
                    if (old_score == current_score)
                        return false;

                    var old_homeGoals = parseInt(old_score.split(':')[0].trim());
                    var old_awayGoals = parseInt(old_score.split(':')[1].trim());
                    var current_homeGoals = parseInt(current_score.split(':')[0].trim());
                    var current_awayGoals = parseInt(current_score.split(':')[1].trim());
                    var current_goals = current_homeGoals + current_awayGoals;

                    if (dItem.ref_score == 'Home' && current_homeGoals > old_homeGoals) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'Draw' && current_homeGoals === current_awayGoals) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'Away' && current_awayGoals > old_awayGoals) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'BTS' && current_homeGoals > 0 && current_awayGoals > 0) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'Over 0.5' && current_goals > 0) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 1.5' && current_goals > 1) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 2.5' && current_goals > 2) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 3.5' && current_goals > 3) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 4.5' && current_goals > 4) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }
                
            },
            check_autoCoverCashout(dItem, fIndex) {
                if (dItem.cover_ref_profitPts) {
                    var val = parseFloat(dItem.cover_ref_profitPts);
                    if (dItem.cover_currentPointProfit >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_profitPro) {
                    var val = parseFloat(dItem.cover_ref_profitPro);
                    var profitPro = 100 * (dItem.cover_currentPointProfit / dItem.cover_stake)
                    if (profitPro >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_stoploss) {
                    var val = -1 * parseFloat(dItem.cover_ref_stoploss);
                    var profitPro = 100 * (dItem.cover_currentPointProfit / dItem.cover_stake) 
                    if (profitPro <= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_nextodd) {
                    var val = parseFloat(dItem.cover_ref_nextodd);
                    
                    if (dItem.cover_currentOdd && dItem.cover_currentOdd >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_nextodd_lower) {
                    var val = parseFloat(dItem.cover_ref_nextodd_lower);
                    
                    if (dItem.cover_currentOdd && dItem.cover_currentOdd <= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_time) {
                    var val = parseFloat(dItem.cover_ref_time);                    
                    if (dItem.current_minute && dItem.current_minute >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');

                        console.log('==========   because of time')
                        return true;
                    }
                }

                if (dItem.cover_ref_score) {
                    var old_score = dItem.ref_momnent_score;
                    var current_score = dItem.currentScore;
                    if (old_score == current_score)
                        return false;

                    var old_homeGoals = parseInt(old_score.split(':')[0].trim());
                    var old_awayGoals = parseInt(old_score.split(':')[1].trim());
                    var current_homeGoals = parseInt(current_score.split(':')[0].trim());
                    var current_awayGoals = parseInt(current_score.split(':')[1].trim());
                    var current_goals = current_homeGoals + current_awayGoals;

                    if (dItem.cover_ref_score == 'Home' && current_homeGoals > old_homeGoals) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'Draw' && current_homeGoals === current_awayGoals) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'Away' && current_awayGoals > old_awayGoals) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'BTS' && current_homeGoals > 0 && current_awayGoals > 0) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'Over 0.5' && current_goals > 0) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 1.5' && current_goals > 1) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 2.5' && current_goals > 2) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 3.5' && current_goals > 3) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 4.5' && current_goals > 4) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }
                

            },

            handleStatsClick() {
                const {id, userId} = this.$route.params;
                
                let routeData = this.$router.resolve({
                    name: 'UserStrategyStats',
                    params: {
                        id: id,
                        userId: userId
                    }
                });
                window.open(routeData.href, '_blank');
            },
            handleFinancialClick() {
                const {id, userId} = this.$route.params; 
                let routeData = this.$router.resolve({
                    name: 'UserStrategyFinancial',
                    params: {
                        id: id,
                        userId: userId
                    }
                });
                window.open(routeData.href, '_blank');
            },

            makeFeed(fItem) {
                let comments = [];
                
                let fixture = fItem.fixture[0];
                if (fixture.stage_has_standings)
                    fItem['eventName'] = `${fixture.localTeamName} (${fixture.home_rank}) v ${fixture.visitorTeamName} (${fixture.away_rank})`;
                else
                    fItem['eventName'] = `${fixture.localTeamName} v ${fixture.visitorTeamName}`;
                let startingAt = convertUTCToLocal(fixture.time.starting_at.date_time);
                fItem['startingAt'] = startingAt.toLocaleDateString() + ' ' + startingAt.toLocaleTimeString();
                fItem['status'] = fItem.status;
                let dateTime = convertUTCToLocal(fItem.dateTime, (new Date()).getTimezoneOffset() / 60);
                fItem['dateTime'] = defaultFormat(dateTime);
                const {scores} = fixture;
                if(['FT', 'AET', 'FT_PEN'].includes(fixture.time.status)){
                    if (scores.ft_score) 
                        fItem['result'] = `${scores.ft_score} FT(${scores.ht_score} HT)`;
                    else
                        fItem['result'] = `${scores.localteam_score}-${scores.visitorteam_score} FT(${scores.ht_score} HT)`;
                }
                fItem['replyTo'] = [];

                const {selected} = this.$route.params;
                var openComments = false;
                fItem.comments.forEach((cItem) => {
                    var unread = false;
                    if (this.notifications.length > 0) {
                        unread = this.notifications.find(nItem => nItem.commentId === cItem._id && !nItem.readAt)
                    }
                    
                    comments.push({
                        ...cItem,
                        dateTime: defaultFormat(convertUTCToLocal(cItem.dateTime, (new Date()).getTimezoneOffset() / 60)),
                        userName: cItem.user[0].alias,
                        userAvatar: `${cItem.user[0].avatar}`,
                        unread: unread
                    });
                    if (cItem._id == selected){
                        openComments = true;
                    }
                });                
                
                fItem = {
                    ...fItem  ,
                    userName: fItem.user[0].alias,
                    userAvatar: `${fItem.user[0].avatar}`,
                    comments,
                    followTip: (fItem.follow || []).includes(parseInt(this.loggedInUser.user_id)),
                    likeTip: (fItem.like || []).includes(parseInt(this.loggedInUser.user_id)),
                    followUserCount: (fItem.followingUsers || []).length,
                    openComments: openComments
                };

                var currentStatus = '';
                var currentScore = '';
                var currentPointProfit = '';
                var currentOdd = '';
                var currentOdd_suspended = false;
                var cashOut = '';

                var cover_currentPointProfit = '';
                var cover_currentOdd = '';
                var cover_currentOdd_suspended = false;
                var cover_cashOut = '';
                var cover_cashOut_flag = false;
                if (fItem.cover_predictionType && fItem.cover_stake && fItem.cover_odd)
                    cover_cashOut_flag = true;

                const drawnobet_market_ids = [28082,137918013,136696391];

                if (fItem.cashout || fItem.settled !== 0) {
                    const scores = fItem.fixture[0].scores;
                    if (scores.ft_score && scores.ht_score)
                        currentStatus = `${scores.ft_score} FT(${scores.ht_score} HT)`;
                    else if (scores.ht_score)
                        currentStatus = `${scores.ht_score} HT`;
                    else
                        currentStatus = 'NS';
                } else if (fItem.settled === 0) {
                    const fixture = fItem.fixture;
                    const status = fixture[0].time.status;
                    const time = fixture[0].time;
                    const scores = fixture[0].scores;
                    /** get current status */
                    currentStatus = status;
                    if (status === 'LIVE' || status === 'HT') {
                        let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                        let second = time.second ? time.second : '00';
                        let added_time = time.added_time ? `+${time.added_time}\'` : '';
                        currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                    }
                    /** current score */
                    currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                    /** get current odd */
                    let odds = [];
                    const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                    const ht_market_ids = [37, 31379, 975903, 976226, 31359];

                    if (status === 'LIVE' || status == 'HT') {
                        odds = fixture[0].inplayOdds.data;
                    } else if (status === 'NS') {
                        odds = fixture[0].flatOdds.data;
                    }
                    odds
                        .filter(item => item.bookmaker_id === 2)
                        .forEach(oItem => {
                            let suffix = '';
                            if (ft_market_ids.includes(oItem.market_id))
                                suffix = 'FT';
                            else if (ht_market_ids.includes(oItem.market_id))
                                suffix = 'HT';
                            else if(oItem.market_id == 63)
                                suffix = 'Double chance';
                            else if (drawnobet_market_ids.includes(oItem.market_id))
                                suffix = 'Draw no bet';

                            (oItem.odds || oItem.values).forEach((item, index) => {
                                let label;
                                if (oItem.market_id == 63) {
                                    if (index == 0)
                                        label = '1X';
                                    else if (index == 1)
                                        label = 'X2';
                                    else
                                        label = '12';
                                }
                                else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                    if (index == 0)
                                        label = 'Home';
                                    else if (index == 1)
                                        label = 'Away';
                                }
                                else {
                                    if (item.label)
                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                    else if (item.team)
                                        label = item.team;
                                    else if (item.info) {
                                        label = item.info;
                                    }
                                    if (label === 'Yes')
                                        label = 'BTS';
                                    else if (label === 'No')
                                        label = 'No BTS';
                                    if (label === '1')
                                        label = "Home";
                                    else if (label === '2')
                                        label = 'Away';
                                    else if (label === 'X')
                                        label = 'Draw';
                                }
                                
                                if (`${label} - ${suffix}`.trim() === fItem.predictionType){
                                    currentOdd = parseFloat(item.value);                                    
                                    if (oItem.suspended !== null)
                                        currentOdd_suspended = oItem.suspended;
                                    else
                                        currentOdd_suspended = item.suspend;
                                }

                               

                            });
                        });
                    if (currentOdd) {
                        
                        /** cash out */
                        cashOut = parseFloat((fItem.odd * fItem.stake / currentOdd).toFixed(2));
                        /** current point profit */
                        currentPointProfit = parseFloat((cashOut - fItem.stake).toFixed(2));
                    }
                   
                }

                if (fItem.settled === 0 && cover_cashOut_flag) {
                    const fixture = fItem.fixture;
                    const status = fixture[0].time.status;
                    const time = fixture[0].time;
                    const scores = fixture[0].scores;
                    /** get current status */
                    currentStatus = status;
                    if (status === 'LIVE' || status === 'HT') {
                        let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                        let second = time.second ? time.second : '00';
                        let added_time = time.added_time ? `+${time.added_time}\'` : '';
                        currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                    }
                    /** current score */
                    currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                    /** get current odd */
                    let odds = [];
                    const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                    const ht_market_ids = [37, 31379, 975903, 976226, 31359];

                    if (status === 'LIVE' || status == 'HT') {
                        odds = fixture[0].inplayOdds.data;
                    } else if (status === 'NS') {
                        odds = fixture[0].flatOdds.data;
                    }
                    odds
                        .filter(item => item.bookmaker_id === 2)
                        .forEach(oItem => {
                            let suffix = '';
                            if (ft_market_ids.includes(oItem.market_id))
                                suffix = 'FT';
                            else if (ht_market_ids.includes(oItem.market_id))
                                suffix = 'HT';
                            else if(oItem.market_id == 63)
                                suffix = 'Double chance';
                            else if (drawnobet_market_ids.includes(oItem.market_id))
                                suffix = 'Draw no bet';
                            (oItem.odds || oItem.values).forEach((item, index) => {
                                let label;
                                if (oItem.market_id == 63) {
                                    if (index == 0)
                                        label = '1X';
                                    else if (index == 1)
                                        label = 'X2';
                                    else
                                        label = '12';
                                }
                                else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                    if (index == 0)
                                        label = 'Home';
                                    else if (index == 1)
                                        label = 'Away';
                                }
                                else {
                                    if (item.label)
                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                    else if (item.team)
                                        label = item.team;
                                    else if (item.info) {
                                        label = item.info;
                                    }
                                    if (label === 'Yes')
                                        label = 'BTS';
                                    else if (label === 'No')
                                        label = 'No BTS';
                                    if (label === '1')
                                        label = "Home";
                                    else if (label === '2')
                                        label = 'Away';
                                    else if (label === 'X')
                                        label = 'Draw';
                                }
                                
                                if (`${label} - ${suffix}`.trim() === fItem.cover_predictionType){
                                    cover_currentOdd = parseFloat(item.value);
                                    
                                    if (oItem.suspended !== null)
                                        cover_currentOdd_suspended = oItem.suspended;
                                    else
                                        cover_currentOdd_suspended = item.suspend;
                                }

                            });
                        });                   
                    if (cover_currentOdd) {
                        
                        /** cash out */
                        cover_cashOut = parseFloat((fItem.cover_odd * fItem.cover_stake / cover_currentOdd).toFixed(2));
                        /** current point profit */
                        cover_currentPointProfit = parseFloat((cover_cashOut - fItem.cover_stake).toFixed(2));
                    }
                }

                fItem = {
                    ...fItem,
                    currentStatus:  currentStatus,
                    currentScore: currentScore,
                    currentPointProfit: currentPointProfit,
                    currentOdd: currentOdd,
                    currentOdd_suspended: currentOdd_suspended,
                    cashOut: cashOut,
                    cover_currentPointProfit: cover_currentPointProfit,
                    cover_currentOdd: cover_currentOdd,
                    cover_currentOdd_suspended: cover_currentOdd_suspended,
                    cover_cashOut: cover_cashOut,
                    cover_cashOut_flag: cover_cashOut_flag,
                    online_refreshKey: this.create_UUID()
                };


                return fItem;
                
            },
            create_UUID(){
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid
            },
            checkCashOut() {
               
                for (var cIndex=0; cIndex < this.cashoutQueue.length; cIndex++) {
                    var cItem = this.cashoutQueue[cIndex];

                    if ((cItem.auto_cashout == 'tip' || cItem.auto_cashout == 'cover') && cItem.first_input ) {
                        this.cashoutQueue[cIndex].first_input = false;
                        console.log('skip one')
                        continue;
                    }

                
                    let fIndex = this.data.findIndex(item => item._id === cItem._id);
                    
                    if(fIndex > -1) {
                        
                        // if (_data[fIndex].openComments === false) {
                        let just = this.data[fIndex];
                        
                        if ((cItem.cashout_type === 0 && cItem.currentOdd === just.currentOdd) || (cItem.cashout_type === 1 && cItem.cover_currentOdd === just.cover_currentOdd) && cItem.currentScore === just.currentScore)
                            
                        {
                            console.log('=== infinite loop ')
                            try {
                                this.cashOut(cItem).then((res) => {
                                    let temp = {
                                        ...this.data[fIndex],
                                        ...res.data
                                    }
                                   
                                    let dateTime = convertUTCToLocal(temp.dateTime, (new Date()).getTimezoneOffset() / 60);
                                    temp['dateTime'] = defaultFormat(dateTime);
                                    
                                    this.data.splice(fIndex, 1);
                                    this.data.unshift(temp);
                                    displaySuccess(res);
                                });
                            } catch(err) {
                                displayError(err);
                            } finally {                                
                                this.cashoutQueue.splice(cIndex, 1);
                            }
                        } else {
                            if(this.cashoutQueue.length > 0) {
                                if (cItem.auto_cashout == 'tip' || cItem.auto_cashout =='cover') {
                                    let cashout_ref = {};
                                    let cover_cashout_ref = {};

                                    if (cItem.auto_cashout == 'tip') {
                                        cashout_ref = {
                                            'ref_numOfAttempt': parseInt(cItem.ref_numOfAttempt) - 1
                                        }
                                        this.data[fIndex].ref_numOfAttempt = parseInt(cItem.ref_numOfAttempt) - 1
                                    }
                                    else {
                                        cover_cashout_ref = {
                                            'cover_ref_numOfAttempt': parseInt(cItem.cover_ref_numOfAttempt) - 1
                                        }
                                        this.data[fIndex].cover_ref_numOfAttempt = parseInt(cItem.cover_ref_numOfAttempt) - 1
                                    }

                                    this.postCashoutRef({_id: cItem._id, cashout_ref: cashout_ref, cover_cashout_ref: cover_cashout_ref}).then((data) => {
                                        console.log('=====     attempt num reduced   =====')
                                        
                                    }).finally(() => {
                                        this.cashoutQueue.splice(cIndex, 1);
                                        displayError({message: "Posting failed due to change of odds or score."});
                                    });
                                }
                                else {
                                    this.cashoutQueue.splice(cIndex, 1);
                                    displayError({message: "Posting failed due to change of odds or score."});
                                }
                            }
                        }
                        
                        break;
                    }
                    
                }
            },

            loadMore(numberOfItems) {
                this.loadmore_loading = true;
                const {id, userId} = this.$route.params;
                this.getFeedsByStrategy_({id: id, userId: parseInt(userId), num: parseInt(numberOfItems)}).then(({data: {feeds}}) => {
                    
                    feeds.sort((a, b) => {
                        return Math.abs(a.settled) - Math.abs(b.settled);
                    });

                    feeds.forEach(fItem => {
                        
                        let fIndex = this.data.findIndex(item => item._id === fItem._id);
                        if (fIndex < 0)
                            this.data.push(this.makeFeed(fItem)); 
                    });
                }).finally(() => {
                    this.loadmore_loading = false;
                });
            },

            handleDeleteTip(tip_id) {
                
                Swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                           this.deleteTip({tip_id: tip_id}).then((data) => {
                                let idx = this.data.findIndex(item => item._id === tip_id);
                                this.data.splice(idx, 1);

                                
                            }).finally(() => {
                                console.log('final');
                            });
                        }
                    });
            },
            handleDeleteComment(tip_id, comment_id) {
                
                Swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                           this.deleteComment({comment_id: comment_id}).then((data) => {
                                let idx = this.data.findIndex(item => item._id === tip_id);

                                let comment_idx = this.data[idx].comments.findIndex(item => item._id === comment_id)
                                this.data[idx].comments.splice(comment_idx, 1);

                                
                            }).finally(() => {
                                console.log('final');
                            });
                        }
                    });
            },
            handleReset() {
                Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, reset it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // let user_id = localStorage.getItem('user_id');
                            // this.resetTip({user_id}).then(({status}) => {
                            //     if(status === 'success') {
                            //         this.data = this.data.filter(dItem => dItem.settled === 0 || dItem.type === 'label');
                            //         this.stat = {
                            //             ...this.stat,
                            //             total_tips: 0,
                            //             roi:  0,
                            //             profit_pts: 0,
                            //             w_rate: 0,
                            //             resetCount: this.stat.resetCount + 1
                            //         };
                            //     }
                            // });
                        }
                    })
            },
            init() {
                this.runTimer();
                const {id, notifications, userId} = this.$route.params;
                console.log('userId===', userId)
                if(notifications) {
                    this.notifications = notifications.slice();
                }
                
                this.data = [];
                this.getFeedsByStrategy({id: id, userId: userId}).then(({data: {feeds, stat, strategy, total_stat, stat1, userIsFollowed, strategyIsFollowed}}) => {

                    this.userIsFollowed = userIsFollowed;
                    this.strategyIsFollowed = strategyIsFollowed;

                    console.log('userIsFollowed', userIsFollowed)
                    this.strategy = strategy;
                    this.stat = {
                        ...this.stat,
                        userId: parseInt(stat.user[0]._id),
                        userName: stat.user[0].alias,
                        userAvatar: stat.user[0].avatar,
                        followers: stat.followers,
                        resetCount: stat.resetCount
                    }

                    this.total_stat = {
                        ...this.total_stat,
                        userId: parseInt(stat.user[0]._id),
                        userName: total_stat.user[0].alias,
                        userAvatar: total_stat.user[0].avatar,
                        followers: total_stat.followers,
                        resetCount: total_stat.resetCount
                    }
                    if(stat.totalCount) {
                        this.stat = {
                            ...this.stat,
                            total_tips: stat.totalCount,
                            roi:  stat.stakeTotal ? (stat.profitPTS / stat.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: stat.profitPTS.toFixed(2),
                            w_rate: stat.settledLose + stat.settledWin ? ((stat.settledWin / (stat.settledLose + stat.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: stat.settledLose + stat.settledWin ? ((stat.totalOdd / (stat.settledLose + stat.settledWin))).toFixed(2) : 0,
                        };
                    }
                    if(total_stat.totalCount) {
                        this.total_stat = {
                            ...this.total_stat,
                            total_tips: total_stat.totalCount,
                            roi:  total_stat.stakeTotal ? (total_stat.profitPTS / total_stat.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: total_stat.profitPTS.toFixed(2),
                            w_rate: total_stat.settledLose + total_stat.settledWin ? ((total_stat.settledWin / (total_stat.settledLose + total_stat.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: total_stat.settledLose + total_stat.settledWin ? ((total_stat.totalOdd / (total_stat.settledLose + total_stat.settledWin))).toFixed(2) : 0,
                        };
                    }
                    if(stat1.totalCount) {
                        this.real_stat = {
                            ...this.real_stat,
                            total_tips: stat1.totalCount,
                            roi:  stat1.stakeTotal ? (stat1.profitPTS / stat1.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: stat1.profitPTS.toFixed(2),
                            w_rate: stat1.settledLose + stat1.settledWin ? ((stat1.settledWin / (stat1.settledLose + stat1.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: stat1.settledLose + stat1.settledWin ? ((stat1.totalOdd / (stat1.settledLose + stat1.settledWin))).toFixed(2) : 0,
                        };
                    }
                    feeds = feeds.filter( item => item.fixture.length > 0 );
                    feeds.forEach((fItem) => {
                        let fixture = fItem.fixture[0];
                        if (fixture.stage_has_standings)
                            fItem['eventName'] = `${fixture.localTeamName} (${fixture.home_rank}) v ${fixture.visitorTeamName} (${fixture.away_rank})`;
                        else
                            fItem['eventName'] = `${fixture.localTeamName} v ${fixture.visitorTeamName}`;
                        let startingAt = convertUTCToLocal(fixture.time.starting_at.date_time);
                        fItem['startingAt'] = startingAt.toLocaleDateString() + ' ' + startingAt.toLocaleTimeString();
                        fItem['status'] = fItem.status;
                        let dateTime = convertUTCToLocal(fItem.dateTime, (new Date()).getTimezoneOffset() / 60);
                        fItem['dateTime'] = defaultFormat(dateTime);
                        const {scores} = fixture;
                        if(['FT', 'AET', 'FT_PEN'].includes(fixture.time.status)){
                            if (scores.ft_score) 
                                fItem['result'] = `${scores.ft_score} FT(${scores.ht_score} HT)`;
                            else
                                fItem['result'] = `${scores.localteam_score}-${scores.visitorteam_score} FT(${scores.ht_score} HT)`;
                        }
                        if(fItem.settled === -1)
                            fItem['pts'] = fItem.stake * (-1);
                        else if(fItem.settled === 1)
                            fItem['pts'] = (fItem.stake * (fItem.odd - 1)).toFixed(2);
                        fItem['replyTo'] = [];

                        /*  modify at 2021.10.26 */
                        var currentStatus = '';
                        var currentScore = '';
                        var currentPointProfit = '';
                        var currentOdd = '';
                        var currentOdd_suspended = false;
                        var cashOut = '';

                        var cover_currentPointProfit = '';
                        var cover_currentOdd = '';
                        var cover_currentOdd_suspended = false;
                        var cover_cashOut = '';
                        var cover_cashOut_flag = false;
                        if (fItem.cover_predictionType && fItem.cover_stake && fItem.cover_odd)
                            cover_cashOut_flag = true;

                        const drawnobet_market_ids = [28082,137918013,136696391];

                        if (fItem.cashout || fItem.settled !== 0) {
                            const scores = fItem.fixture[0].scores;
                            if (scores.ft_score && scores.ht_score)
                                currentStatus = `${scores.ft_score} FT(${scores.ht_score} HT)`;
                            else if (scores.ht_score)
                                currentStatus = `${scores.ht_score} HT`;
                            else
                                currentStatus = 'NS';
                        } else if (fItem.settled === 0) {
                            const fixture = fItem.fixture;
                            const status = fixture[0].time.status;
                            const time = fixture[0].time;
                            const scores = fixture[0].scores;
                            /** get current status */
                            currentStatus = status;
                            if (status === 'LIVE' || status === 'HT') {
                                let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                                let second = time.second ? time.second : '00';
                                let added_time = time.added_time ? `+${time.added_time}\'` : '';
                                currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                            }
                            /** current score */
                            currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                            /** get current odd */
                            let odds = [];
                            const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                            const ht_market_ids = [37, 31379, 975903, 976226, 31359];

                            if (status === 'LIVE' || status == 'HT') {
                                odds = fixture[0].inplayOdds.data;
                            } else if (status === 'NS') {
                                odds = fixture[0].flatOdds.data;
                            }
                            odds
                                .filter(item => item.bookmaker_id === 2)
                                .forEach(oItem => {
                                    let suffix = '';
                                    if (ft_market_ids.includes(oItem.market_id))
                                        suffix = 'FT';
                                    else if (ht_market_ids.includes(oItem.market_id))
                                        suffix = 'HT';
                                    else if(oItem.market_id == 63)
                                        suffix = 'Double chance';
                                    else if (drawnobet_market_ids.includes(oItem.market_id))
                                        suffix = 'Draw no bet';
                                    (oItem.odds || oItem.values).forEach((item, index) => {
                                        let label;
                                        if (oItem.market_id == 63) {
                                            if (index == 0)
                                                label = '1X';
                                            else if (index == 1)
                                                label = 'X2';
                                            else
                                                label = '12';
                                        }
                                        else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                            if (index == 0)
                                                label = 'Home';
                                            else if (index == 1)
                                                label = 'Away';
                                        }
                                        else {
                                            if (item.label)
                                                label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                            else if (item.team)
                                                label = item.team;
                                            else if (item.info) {
                                                label = item.info;
                                            }
                                            if (label === 'Yes')
                                                label = 'BTS';
                                            else if (label === 'No')
                                                label = 'No BTS';
                                            if (label === '1')
                                                label = "Home";
                                            else if (label === '2')
                                                label = 'Away';
                                            else if (label === 'X')
                                                label = 'Draw';
                                        }
                                        
                                        if (`${label} - ${suffix}`.trim() === fItem.predictionType){
                                            currentOdd = parseFloat(item.value);
                                            currentOdd_suspended = oItem.suspended;
                                        }
                                    });
                                });
                            if (currentOdd) {
                                
                                /** cash out */
                                cashOut = parseFloat((fItem.odd * fItem.stake / currentOdd).toFixed(2));
                                /** current point profit */
                                currentPointProfit = parseFloat((cashOut - fItem.stake).toFixed(2));
                            }
                           
                        }

                        if (fItem.settled === 0 && cover_cashOut_flag) {
                            const fixture = fItem.fixture;
                            const status = fixture[0].time.status;
                            const time = fixture[0].time;
                            const scores = fixture[0].scores;
                            /** get current status */
                            currentStatus = status;
                            if (status === 'LIVE' || status === 'HT') {
                                let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                                let second = time.second ? time.second : '00';
                                let added_time = time.added_time ? `+${time.added_time}\'` : '';
                                currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                            }
                            /** current score */
                            currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                            /** get current odd */
                            let odds = [];
                            const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                            const ht_market_ids = [37, 31379, 975903, 976226, 31359];

                            

                            if (status === 'LIVE' || status == 'HT') {
                                odds = fixture[0].inplayOdds.data;
                            } else if (status === 'NS') {
                                odds = fixture[0].flatOdds.data;
                            }
                            odds
                                .filter(item => item.bookmaker_id === 2)
                                .forEach(oItem => {
                                    let suffix = '';

                                    if (ft_market_ids.includes(oItem.market_id))
                                        suffix = 'FT';
                                    else if (ht_market_ids.includes(oItem.market_id))
                                        suffix = 'HT';
                                    else if(oItem.market_id == 63)
                                        suffix = 'Double chance';
                                    else if (drawnobet_market_ids.includes(oItem.market_id))
                                        suffix = 'Draw no bet';
                                    (oItem.odds || oItem.values).forEach((item, index) => {
                                        let label;

                                        if (oItem.market_id == 63) {
                                            if (index == 0)
                                                label = '1X';
                                            else if (index == 1)
                                                label = 'X2';
                                            else
                                                label = '12';
                                        }
                                        else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                            if (index == 0)
                                                label = 'Home';
                                            else if (index == 1)
                                                label = 'Away';
                                        }
                                        else {
                                            if (item.label)
                                                label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                            else if (item.team)
                                                label = item.team;
                                            else if (item.info) {
                                                label = item.info;
                                            }
                                            if (label === 'Yes')
                                                label = 'BTS';
                                            else if (label === 'No')
                                                label = 'No BTS';
                                            if (label === '1')
                                                label = "Home";
                                            else if (label === '2')
                                                label = 'Away';
                                            else if (label === 'X')
                                                label = 'Draw';   
                                        }
                                                                     
                                        
                                        if (`${label} - ${suffix}`.trim() === fItem.cover_predictionType){
                                            cover_currentOdd = parseFloat(item.value);
                                            cover_currentOdd_suspended = oItem.suspended;
                                        }

                                    });
                                });                   
                            if (cover_currentOdd) {
                                
                                /** cash out */
                                cover_cashOut = parseFloat((fItem.cover_odd * fItem.cover_stake / cover_currentOdd).toFixed(2));
                                /** current point profit */
                                cover_currentPointProfit = parseFloat((cover_cashOut - fItem.cover_stake).toFixed(2));
                            }
                        }

                        
                        fItem['currentStatus'] = currentStatus
                        fItem['currentScore'] =  currentScore
                        fItem['currentPointProfit'] = currentPointProfit
                        fItem['currentOdd'] = currentOdd
                        fItem['currentOdd_suspended'] = currentOdd_suspended
                        fItem['cashOut'] = cashOut
                        fItem['cover_currentPointProfit'] = cover_currentPointProfit
                        fItem['cover_currentOdd'] = cover_currentOdd
                        fItem['cover_currentOdd_suspended'] = cover_currentOdd_suspended
                        fItem['cover_cashOut'] = cover_cashOut
                        fItem['cover_cashOut_flag'] = cover_cashOut_flag
                        fItem['openComments'] = false;
                        
                        /*  modify at 2021.10.26 */
                    });
                    /** count settled tips */
                    const settledTips = feeds.filter(fItem => fItem.settled).length;
                    // const pendingTips = this.stat.total_tips - settledTips;
                    const pendingTips = feeds.filter(fItem => !fItem.settled).length;
                    /** insert label for Settled tips */
                    // this.data.push({
                    //     type: 'label',
                    //     color: 'warning',
                    //     text: 'Pending Tips',
                    //     count: pendingTips
                    // });
                    feeds.sort((a, b) => {
                        return Math.abs(a.settled) - Math.abs(b.settled);
                    });
                    feeds.forEach(fItem => {
                        let comments = [];
                        fItem.comments.forEach((cItem) => {
                            comments.push({
                                ...cItem,
                                dateTime: defaultFormat(convertUTCToLocal(cItem.dateTime, (new Date()).getTimezoneOffset() / 60)),
                                userName: cItem.user[0].alias,
                                userAvatar: `${cItem.user[0].avatar}`
                            });
                        });
                        this.data.push({
                            ...fItem  ,
                            userName: fItem.user[0].alias,
                            userAvatar: `${fItem.user[0].avatar}`,
                            comments,
                            followTip: (fItem.follow || []).includes(parseInt(this.loggedInUser.user_id)),
                            likeTip: (fItem.like || []).includes(parseInt(this.loggedInUser.user_id)),
                            followUserCount: (fItem.followingUsers || []).length,
                            online_refreshKey: this.create_UUID()
                        });
                    });
                    
                    let fIndex = this.data.findIndex(fItem => fItem.settled);
                    if(fIndex === -1) {
                        fIndex = this.data.length;
                    } 
                    /** insert label for Pending Tips */
                    // this.data.splice(fIndex, 0, {
                    //     type: 'label',
                    //     color: 'success',
                    //     text: 'Settled Tips',
                    //     count: settledTips
                    // });
                }).finally(() => {
                    this.runTimer(false);
                    /** move scroll to one from notification */
                    const {selected} = this.$route.params;
                    if(selected) {
                        setTimeout(() => {
                            this.$nextTick(() => {
                                var el = document.querySelector(`#id${selected}`);
                                el.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center'
                                });
                            });
                        }, 500);
                    }
                });
            },
            updateCashOut() {
                this.getMyPendingFeeds().then(({data}) => {                    
                    data.forEach((dItem) => {
                        let fIndex = this.data.findIndex(item => item._id === dItem._id);
                        
                        if(fIndex > -1) {
                            /** update fixture */
                            var currentStatus = '';
                            var currentScore = '';
                            var currentPointProfit = '';
                            var currentOdd = '';
                            var currentOdd_suspended = false;
                            var cashOut = '';

                            var cover_currentPointProfit = '';
                            var cover_currentOdd = '';
                            var cover_currentOdd_suspended = false;
                            var cover_cashOut = '';
                            var cover_cashOut_flag = false;

                            var current_minute = null;

                            if (dItem.cover_predictionType && dItem.cover_stake && dItem.cover_odd)
                                cover_cashOut_flag = true;

                            if (dItem.settled === 0) {
                                const fixture = dItem.fixture;
                                const status = fixture[0].time.status;
                                const time = fixture[0].time;
                                const scores = fixture[0].scores;
                                /** get current status */
                                currentStatus = status;
                                if (status === 'LIVE' || status === 'HT') {
                                    let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                                    let second = time.second ? time.second : '00';
                                    let added_time = time.added_time ? `+${time.added_time}\'` : '';
                                    currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                                    current_minute = time.minute;
                                }
                                /** current score */
                                currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                                /** get current odd */
                                let odds = [];
                                const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                                const ht_market_ids = [37, 31379, 975903, 976226, 31359];
                                const drawnobet_market_ids = [28082,137918013,136696391];

                                if (status === 'LIVE' || status == 'HT') {
                                    odds = fixture[0].inplayOdds.data;
                                } else if (status === 'NS') {
                                    odds = fixture[0].flatOdds.data;
                                }
                                odds
                                    .filter(item => item.bookmaker_id === 2)
                                    .forEach(oItem => {
                                        let suffix = '';
                                        if (ft_market_ids.includes(oItem.market_id))
                                            suffix = 'FT';
                                        else if (ht_market_ids.includes(oItem.market_id))
                                            suffix = 'HT';
                                        else if(oItem.market_id == 63)
                                            suffix = 'Double chance';
                                        else if (drawnobet_market_ids.includes(oItem.market_id))
                                            suffix = 'Draw no bet';
                                        (oItem.odds || oItem.values).forEach((item, index) => {
                                            let label;
                                            if (oItem.market_id == 63) {
                                                if (index == 0)
                                                    label = '1X';
                                                else if (index == 1)
                                                    label = 'X2';
                                                else
                                                    label = '12';
                                            }
                                            else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                                if (index == 0)
                                                    label = 'Home';
                                                else if (index == 1)
                                                    label = 'Away';
                                            }
                                            else {
                                                if (item.label)
                                                    label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                                else if (item.team)
                                                    label = item.team;
                                                else if (item.info) {
                                                    label = item.info;
                                                }
                                                if (label === 'Yes')
                                                    label = 'BTS';
                                                else if (label === 'No')
                                                    label = 'No BTS';
                                                if (label === '1')
                                                    label = "Home";
                                                else if (label === '2')
                                                    label = 'Away';
                                                else if (label === 'X')
                                                    label = 'Draw';
                                            }
                                            

                                            if (`${label} - ${suffix}`.trim() === dItem.predictionType) {
                                                currentOdd = parseFloat(item.value);
                                                if (oItem.suspended !== null)
                                                    currentOdd_suspended = oItem.suspended;
                                                else
                                                    currentOdd_suspended = item.suspend;
                                                
                                            }
                                            if (`${label} - ${suffix}`.trim() === dItem.cover_predictionType){
                                                cover_currentOdd = parseFloat(item.value);
                                                if (oItem.suspended !== null)
                                                    cover_currentOdd_suspended = oItem.suspended;
                                                else
                                                    cover_currentOdd_suspended = item.suspend;
                                            }

                                        });
                                    });
                                if (currentOdd) {
                                    
                                    /** cash out */
                                    cashOut = parseFloat((dItem.odd * dItem.stake / currentOdd).toFixed(2));
                                    /** current point profit */
                                    currentPointProfit = parseFloat((cashOut - dItem.stake).toFixed(2));
                                }
                                if (cover_currentOdd) {
                                    
                                    /** cash out */
                                    cover_cashOut = parseFloat((dItem.cover_odd * dItem.cover_stake / cover_currentOdd).toFixed(2));
                                    /** current point profit */
                                    cover_currentPointProfit = parseFloat((cover_cashOut - dItem.cover_stake).toFixed(2));
                                }
                            }

                            // this.data[fIndex] = {
                            //     ...this.data[fIndex],
                            //     dItem
                            // }

                            let new_item = {
                                ...this.data[fIndex],
                                ...dItem
                            }
                           
                            new_item.currentStatus = currentStatus
                            new_item.currentScore = currentScore
                            new_item.currentPointProfit = currentPointProfit
                            new_item.currentOdd = currentOdd
                            new_item.cashOut = cashOut

                            new_item.currentOdd_suspended = currentOdd_suspended
                            new_item.cover_currentOdd_suspended = cover_currentOdd_suspended

                            new_item.cover_cashOut_flag = cover_cashOut_flag
                            new_item.cover_currentPointProfit = cover_currentPointProfit
                            new_item.cover_currentOdd = cover_currentOdd
                            new_item.cover_cashOut = cover_cashOut
                            new_item.current_minute = current_minute

                            let dateTime = convertUTCToLocal(dItem.dateTime, (new Date()).getTimezoneOffset() / 60);
                            new_item['dateTime'] = defaultFormat(dateTime);
                            
                            this.data.splice(fIndex, 1);
                            this.data.splice(fIndex, 0, new_item);
                           
                            if (this.userId == dItem.userId){
                                if (!dItem.cashout && dItem.ref_numOfAttempt && dItem.ref_numOfAttempt > 0 && currentPointProfit !== '' && currentOdd && !currentOdd_suspended){
                                    let selections = this.cashoutQueue.filter(function(runner) {
                                        return runner._id == new_item._id && runner.auto_cashout == 'tip';
                                    });
                                    if (selections.length == 0){
                                        console.log('auto-tip cash out')
                                        this.check_autoTipCashout(new_item, fIndex);
                                    }
                                }
                                if (!dItem.cover_cashout && dItem.cover_ref_numOfAttempt && dItem.cover_ref_numOfAttempt > 0 && cover_currentPointProfit !== '' && cover_currentOdd && !cover_currentOdd_suspended) {
                                    let selections = this.cashoutQueue.filter(function(runner) {
                                        return runner._id == new_item._id && runner.auto_cashout == 'cover';
                                    });
                                    if (selections.length == 0){
                                        console.log('auto-cover cash out')
                                        this.check_autoCoverCashout(new_item, fIndex);
                                    }
                                }
                            }
                        }
                    });                   

                    this.checkCashOut();
                });
        
            },
        },
        watch: {
            '$route.params': {
                deep: true,
                immediate: true,
                handler(val) {
                    if(!this.loading)
                        this.init();
                }
            }
        },
        mounted() {
            let user_id = localStorage.getItem('user_id');
            this.userId = parseInt(user_id);
            this.sockets.subscribe('new-comment', ({tipId, comments}) => {
                let index = this.data.findIndex(dItem => dItem._id === tipId);
                if(index > -1) {
                    this.data[index].comments = comments.map(cItem => ({
                        ...cItem,
                        dateTime: defaultFormat(convertUTCToLocal(cItem.dateTime, (new Date()).getTimezoneOffset() / 60)),
                        userName: cItem.user[0].alias,
                        userAvatar: `${cItem.user[0].avatar}`
                    }));
                }
            });

            this.sockets.subscribe('newFeed', (feed) => {
                if (feed.strategy == '' || feed.strategy == null)
                    feed.strategy = 'default';

                if ( feed.strategy == this.$route.params.id && feed.userId == this.$route.params.userId ) {
                    if (this.loggedInUser.user_id !=0 && feed.strategyData && feed.strategyData.hide === true) {
                            
                    }
                    else {
                        const temp = this.makeFeed(feed);
                        this.data.unshift(temp);
                        this.total_stat.total_tips = this.total_stat.total_tips + 1;
                        this.real_stat.total_tips = this.real_stat.total_tips + 1;
                        this.stat.total_tips = this.stat.total_tips + 1;                        
                    }
                    
                }
                
            });

            this.sockets.subscribe('tip-settled', ({tip, stat, stat1}) => {

                if (tip.strategy == '' || tip.strategy == null)
                    tip.strategy = 'default';

                if ( tip.strategy == this.$route.params.id && tip.userId == this.$route.params.userId) {
                    // if (this.loggedInUser.user_id !=0) {
                    //     this.stat = {
                    //         ...this.stat,
                    //         total_tips: stat1.totalCount,
                    //         roi:  stat1.stakeTotal ? (stat1.profitPTS / stat1.stakeTotal * 100).toFixed(2) : 0,
                    //         profit_pts: stat1.profitPTS.toFixed(2),
                    //         w_rate: stat1.settledLose + stat1.settledWin ? ((stat1.settledWin / (stat1.settledLose + stat1.settledWin)) * 100).toFixed(2) : 0,
                    //     };
                    // }
                    // else {
                    //     this.stat = {
                    //         ...this.stat,
                    //         total_tips: stat.totalCount,
                    //         roi:  stat.stakeTotal ? (stat.profitPTS / stat.stakeTotal * 100).toFixed(2) : 0,
                    //         profit_pts: stat.profitPTS.toFixed(2),
                    //         w_rate: stat.settledLose + stat.settledWin ? ((stat.settledWin / (stat.settledLose + stat.settledWin)) * 100).toFixed(2) : 0,
                    //     };
                    //     this.real_stat = {
                    //         ...this.real_stat,
                    //         total_tips: stat1.totalCount,
                    //         roi:  stat1.stakeTotal ? (stat1.profitPTS / stat1.stakeTotal * 100).toFixed(2) : 0,
                    //         profit_pts: stat1.profitPTS.toFixed(2),
                    //         w_rate: stat1.settledLose + stat1.settledWin ? ((stat1.settledWin / (stat1.settledLose + stat1.settledWin)) * 100).toFixed(2) : 0,
                    //     }
                    // }
                    
                    console.log("-----------------   tip-settled", tip)
                    let fIndex = this.data.findIndex(item => item._id === tip._id);
                    
                    this.data[fIndex] = {
                        ...this.data[fIndex],
                        ...tip
                    };
                    this.data[fIndex].settled = tip.settled;
                }
                
            });

            this.sockets.subscribe('UpdateUserOnlineStatus', ({onlineUsers, offlineUsers}) => {
                for (let i=0; i < this.data.length; i++) {
                    if (onlineUsers.includes(this.data[i].userId)){
                        this.data[i].online = true;
                        this.online = true;
                    }
                    else
                        this.data[i].online = false;
                    this.data[i].online_refreshKey = this.create_UUID();
                    
                }
                console.log(this.unSettledList)
            });

            this.cashOutTimer = setInterval(this.updateCashOut, 16 * 1000);

        },
        created() {
        },
        beforeDestroy() {
            this.sockets.unsubscribe('new-comment');
            clearInterval(this.cashOutTimer);
        }
    }
</script>
<style lang="scss" scoped>
   .user-stat-page-container {
       .stat {
           display: flex;
           justify-content: space-between;
           margin-bottom: 20px;
           div {
               text-align: center;
           }
           .username {
               div {
                   text-align: left;
               }
               .vue-avatar--wrapper {
                    display: inline-flex !important;
                    margin-right: 5px;
                }
           }
       }
       .username{
           ::v-deep .d-flex{
               .parent_avatar{
                   .vue-avatar--wrapper{
                       border: 5px solid white !important;
                   }
               }
           }
       }
       .header {
           .header-item {
                display: flex;
                justify-content: space-between;
                position: relative;
                div {
                    display: flex;
                }
                .settled-lost {
                    font-weight: 700;
                    color: #FF0000;
                }
                .settled-won {
                    font-weight: 700;
                    color: #00FF00;
                }
           }
       }
       .unread-mark {
           top: 0px;
           left: 0px;
       }
       .note-box {
           position: relative;
           margin-bottom: 20px;
           .note {
               padding: 5px;
               margin: 0 0 10px;
               min-height: 70px;
               background-color: #FEE;
               border-radius: 6px;
           }
           .action-box {
               display: flex;
               .action {
                   border-radius: 5px;
                   padding: 0 5px;
                   margin-right: 10px;
                   min-width: 70px;
                   text-align: center;
                   background-color: rgba(0,0,0,0.1);
                   &.selected {
                       background-color: #39F;
                       color: #FFF;
                   }
               }
           }
       }
       .comments {
           padding: 0 0 0 40px;
           .comment {
               position: relative;
               .comment-header {
                   display: flex;
                   align-items: center;
                   .vue-avatar--wrapper {
                       margin-right: 15px;
                   }
               }
                p {
                    padding-left: 45px;
                }
           }
       }
       .post-comment {
           text-align: right;
           margin-bottom: 10px;
           .btn {
           }
       }
    }   
    .c-callout {
        padding: 1rem;
        margin-top: 50px;
        background-color: #eee !important;
    }
    .strategy_name1{
        text-align: center;
        font-weight: 800;
        font-size: 18px;
        margin-bottom: 0;
    }
    .sub_strategy_name_bar{
        height: 50px;
        background-color: cadetblue;
        color: white;
        font-size: 22px;
        text-align: center;
        padding: 6px;
        font-weight: 700;
    }
    .stat{
        background-color: #5f9ea0;
        color: white;
        padding: 5px 100px 5px 140px;
        position: relative;
        margin-top: 40px;
    }
    .username{
        position: absolute;
        top: 32px;
        left: 60px;
        z-index: 1000;
    }
    .tip_body{
        background-color: whitesmoke;
    }

    .limegreen {
        color: limegreen
    }
    .red {
        color: red
    }
    .feed_card{
        background-color: #f5f5f5;
        border: 1px solid #d3d3d3;
        border-radius: 5px;
        padding: 20px;
        margin-bottom: 20px;
    }
    .handleStats {
        margin-top: 8px;        
        background-color: green;
        border-radius: 5px;
        cursor: pointer;
        min-width: 50px;
    }
    .strategy-name {
        margin: auto;
        font-size: 22px;
        font-weight: bold;
    }
    .stat_button {
        min-width: 100px
    }
  
 
    @media (max-width: 576px){
       .stat{
           padding: 5px !important;
       }
       .username{
        left: 20px;
        top: 32px;

        }
        .stat{
            font-size: 10px !important;
            padding-left: 70px !important;
            padding-right: 10px !important;
        }
        .stat1{
            
            padding-left: 20px !important;
            padding-right: 20px !important;
        }
        .stat > button {
            font-size: 10px;
            padding: 5px !important;
        }
        .strategy-name {            
            font-size: 13px; 
        }
        .stat_button {
            min-width: 60px
        }
    } 

</style>
<style>
    @media (max-width: 576px){
        .strategy_stats_button {
            font-size: 8px;
        }
    }
</style>